import { Skeleton } from '../ui/skeleton';

export const SuspenseLoader: React.FC = () => {
  return (
    <div className="h-full w-full grid grid-cols-1 md:grid-cols-[4fr_1fr] gap-4">
      <div className="flex flex-col justify-start items-center w-full h-full gap-4 p-4 pt-8">
        <Skeleton className="w-full h-16 mb-4" />
        {Array.from({ length: 15 }).map((_, index) => (
          <Skeleton key={index} className="w-full h-8" />
        ))}
      </div>
      <div className="hidden md:flex flex-col justify-start items-center w-full h-full gap-4 p-4">
        <Skeleton className="w-full h-32 mb-4" />
        {Array.from({ length: 10 }).map((_, index) => (
          <Skeleton key={index} className="w-full h-8" />
        ))}
      </div>
    </div>
  );
};
